import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';
import { ButtonDecorator } from '../ButtonDecorator/ButtonDecorator';
import { Loader } from '../Loader/Loader';
import { Shape2, Shape2Icon } from '../Shape2/Shape2';

import './MarketerProductRemoveCell.css';

const BLOCK = 'marketer-product-remove-cell';

export interface MarketerProductRemoveCellProps {
    removeMarketerProduct: () => void;
    isRemoving: boolean;
}

export const MarketerProductRemoveCell = React.memo(function(
    props: MarketerProductRemoveCellProps
) {
    const { removeMarketerProduct, isRemoving } = props;

    if (isRemoving) {
        return <Loader size={'xs'} />;
    }

    return (
        <ButtonDecorator
            theme={'clear'}
            cls={Bem.cls(BLOCK)}
            onClick={removeMarketerProduct}
        >
            <Shape2 icon={Shape2Icon.close} width={15} height={15} />
        </ButtonDecorator>
    );
});
